<template>
  <div class="container">
    <div class="rcv__heading-v1">
      <h1>{{ ballotData.successHeading }}</h1>
    </div>
    <div class="rcv__start-screen-row">
      <div class="rcv__start-screen-left">
        <h2>{{ ballotData.description }}</h2>
        <div class="rcv__voted-list">
          <!-- loop startts here -->
          <!-- sortedCandidates: {{ sortedCandidates }} -->
          <div v-for="(selection, index) in sortedSelections.slice(0, 5)" :key="index" class="rcv__voted-row">
            <div class="rcv__voted-left">
              <div :class="['rcv__candidate-avatar', getCandidateColorClass(selection.candidate.color)]">
                <img :src="selection.candidate.image" alt="" width="90" height="90">
              </div>
            </div>
            <div class="rcv__voted-right">
              <h3>{{ selection.candidate.animalCandidateName }}</h3>
            </div>
          </div>
          <!-- loop ends here -->
        </div>
      </div>
      <div class="rcv__start-screen-right">
        <div class="rcv__text-bubble">
          <div class="rcv__text-bubble-text" v-html="ballotData.rightSideText">
          </div>
          <span class="rcv__text-bubble-arrow"><img src="../../public/assets/rcv-images/down-arrow.svg" alt=""></span>
        </div>
        <div class="rcv__link"> <a :href="ballotData.startOverLink" aria-label="start over">{{
          ballotData.startOverLinkLabel }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessPageComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    },
    sortedSelections: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  computed: {
   
  },

  methods: {
    getCandidateColorClass(color) {
      const colorClassMap = {
        "#fdf751": "rcv__candidate-color-1",
        "#221649": "rcv__candidate-color-2",
        "#4ba3b7": "rcv__candidate-color-3",
        "#ed7aca": "rcv__candidate-color-4",
        "#eb5534": "rcv__candidate-color-5",
        "#367d54": "rcv__candidate-color-6"
      };
      return colorClassMap[color] || "rcv__candidate-color-6"; // default class
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SuccessPageComponent.vue